import React, { useState, useEffect } from 'react'
import { TIPE_KAWASAN, KRITERIA } from './khasConstants'
import { penetapanApi, pengajuanApi } from './khasApi'
import KhasSearchInput from './KhasSearchInput'

/* ── Helper: map penetapan → format zona ─────────────────── */
function mapToZona(pt) {
  return {
    id:   pt.id,
    n:    pt.nama,
    k:    pt.kota,
    p:    pt.provinsi,
    t:    pt.tenant || 0,
    tipe: pt.tipe,
    y:    pt.rencana_peresmian
      ? new Date(pt.rencana_peresmian).getFullYear()
      : new Date(pt.updated_at || pt.created_at).getFullYear(),
  }
}

/* ── Modal Detail ─────────────────────────────────────────── */
function ZonaModal({ zona, detailData, loading, onClose }) {
  if (!zona) return null

  const tipeLabel = TIPE_KAWASAN.find(t => t.value === zona.tipe)?.label || null
  const penetapan = detailData?.penetapan
  const pengajuan = detailData?.pengajuan
  const kriteria  = pengajuan?.kriteria

  return (
    <div onClick={e => e.target === e.currentTarget && onClose()} style={{
      position:'fixed', inset:0, zIndex:1000,
      background:'rgba(0,0,0,0.45)', backdropFilter:'blur(4px)',
      display:'flex', alignItems:'center', justifyContent:'center', padding:16,
    }}>
      <div style={{
        background:'#fff', borderRadius:20, width:'100%', maxWidth:540,
        maxHeight:'90vh', overflowY:'auto',
        boxShadow:'0 32px 80px rgba(0,0,0,0.2)',
      }}>
        {/* Header */}
        <div style={{
          padding:'20px 24px 16px', borderBottom:'1px solid var(--khas-border-l)',
          position:'sticky', top:0, background:'#fff', zIndex:1,
          borderRadius:'20px 20px 0 0',
        }}>
          <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', gap:12 }}>
            <div style={{ flex:1 }}>
              <h3 style={{ margin:'0 0 8px', fontSize:17, fontWeight:700, color:'var(--khas-ink)', lineHeight:1.2 }}>
                {zona.n}
              </h3>
              <div style={{ display:'flex', gap:6, flexWrap:'wrap', alignItems:'center' }}>
                {tipeLabel && (
                  <span style={{ background:'var(--khas-green-l)', color:'var(--khas-green-d)', border:'1px solid #a7f3d0', padding:'3px 10px', borderRadius:99, fontSize:11, fontWeight:600 }}>
                    {tipeLabel}
                  </span>
                )}
                <span style={{ background:'#f0fdf4', color:'#15803d', border:'1px solid #bbf7d0', padding:'3px 10px', borderRadius:99, fontSize:11, fontWeight:600 }}>
                  {zona.y}
                </span>
              </div>
            </div>
            <button onClick={onClose} style={{ background:'none', border:'none', cursor:'pointer', color:'var(--khas-muted)', fontSize:22, lineHeight:1, padding:4, flexShrink:0 }}>
              ×
            </button>
          </div>
        </div>

        {/* Body */}
        <div style={{ padding:'20px 24px' }}>

          {/* Info dasar */}
          <div style={{ marginBottom:18 }}>
            <div style={{ fontSize:11, fontWeight:700, color:'var(--khas-muted)', letterSpacing:'0.06em', marginBottom:10 }}>
              INFORMASI KAWASAN
            </div>
            <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:8 }}>
              {[
                ['Kota',         zona.k || '—'],
                ['Provinsi',     zona.p || '—'],
                ['Total Tenant', zona.t ? `${zona.t} tenant` : '—'],
              ].map(([label, val]) => (
                <div key={label} style={{ background:'var(--khas-surface-low)', borderRadius:10, padding:'10px 14px' }}>
                  <div style={{ fontSize:11, color:'var(--khas-muted)', fontWeight:600, marginBottom:3 }}>{label}</div>
                  <div style={{ fontSize:13.5, color:'var(--khas-ink)', fontWeight:600 }}>{val}</div>
                </div>
              ))}
            </div>
          </div>

          {/* Loading */}
          {loading && (
            <div style={{ textAlign:'center', padding:'24px 0' }}>
              <div className="loader" />
              <div style={{ fontSize:13, color:'var(--khas-muted)', marginTop:10 }}>Memuat detail...</div>
            </div>
          )}

          {/* Detail penetapan */}
          {!loading && penetapan && (
            <>
              <div style={{ borderTop:'1px solid var(--khas-border-l)', paddingTop:16, marginBottom:16 }}>
                <div style={{ fontSize:11, fontWeight:700, color:'var(--khas-muted)', letterSpacing:'0.06em', marginBottom:10 }}>
                  DETAIL PENETAPAN
                </div>
                <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:8 }}>
                  {[
                    ['Tenant Halal',    penetapan.halal ? `${penetapan.halal} tenant` : '—'],
                    ['Tenant Sehat',    penetapan.sehat ? `${penetapan.sehat} tenant` : '—'],
                    ['Ditetapkan oleh', penetapan.ditetapkan_oleh || '—'],
                    ['Tipe Kawasan',    tipeLabel || '—'],
                  ].map(([label, val]) => (
                    <div key={label} style={{ background:'var(--khas-surface-low)', borderRadius:10, padding:'10px 14px' }}>
                      <div style={{ fontSize:11, color:'var(--khas-muted)', fontWeight:600, marginBottom:3 }}>{label}</div>
                      <div style={{ fontSize:13.5, color:'var(--khas-ink)', fontWeight:600 }}>{val}</div>
                    </div>
                  ))}
                </div>
              </div>

              {pengajuan && (
                <div style={{ borderTop:'1px solid var(--khas-border-l)', paddingTop:16, marginBottom:16 }}>
                  <div style={{ fontSize:11, fontWeight:700, color:'var(--khas-muted)', letterSpacing:'0.06em', marginBottom:10 }}>
                    PENGELOLA
                  </div>
                  <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:8 }}>
                    {[
                      ['Nama Pengelola', pengajuan.pic      || '—'],
                      ['Telepon',        pengajuan.telp     || '—'],
                      ['Instansi',       pengajuan.instansi || '—'],
                      ['Email',          pengajuan.email    || '—'],
                    ].map(([label, val]) => (
                      <div key={label} style={{ background:'var(--khas-surface-low)', borderRadius:10, padding:'10px 14px' }}>
                        <div style={{ fontSize:11, color:'var(--khas-muted)', fontWeight:600, marginBottom:3 }}>{label}</div>
                        <div style={{ fontSize:13.5, color:'var(--khas-ink)', fontWeight:600 }}>{val}</div>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {pengajuan && Array.isArray(kriteria) && (
                <div style={{ borderTop:'1px solid var(--khas-border-l)', paddingTop:16 }}>
                  <div style={{ fontSize:11, fontWeight:700, color:'var(--khas-muted)', letterSpacing:'0.06em', marginBottom:10 }}>
                    KRITERIA YANG DIPENUHI ({kriteria.filter(Boolean).length}/{KRITERIA.length})
                  </div>
                  {KRITERIA.map((k, i) => {
                    const ok = kriteria[i] === true
                    return (
                      <div key={i} style={{
                        display:'flex', gap:10, alignItems:'flex-start',
                        padding:'8px 12px', borderRadius:10, marginBottom:6,
                        background: ok ? 'var(--khas-green-l)' : 'var(--khas-surface-low)',
                      }}>
                        <span style={{ fontSize:14, flexShrink:0, fontWeight:700, marginTop:1, color: ok ? 'var(--khas-green-d)' : '#d1d5db' }}>
                          {ok ? '✓' : '○'}
                        </span>
                        <div>
                          <div style={{ fontWeight:600, fontSize:13, color: ok ? 'var(--khas-green-d)' : 'var(--khas-muted)' }}>{k.t}</div>
                          <div style={{ fontSize:12, color:'var(--khas-muted)', marginTop:2 }}>{k.d}</div>
                        </div>
                      </div>
                    )
                  })}
                </div>
              )}
            </>
          )}

          {!loading && !penetapan && (
            <div style={{ borderTop:'1px solid var(--khas-border-l)', paddingTop:14 }}>
              <p style={{ fontSize:13, color:'var(--khas-muted)', textAlign:'center', margin:0 }}>
                Detail tidak dapat dimuat saat ini.
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

/* ── ZCard ────────────────────────────────────────────────── */
function ZCard({ z, onClick }) {
  const tipeLabel = TIPE_KAWASAN.find(t => t.value === z.tipe)?.label

  return (
    <div className="khas-zcard" onClick={onClick} style={{ cursor:'pointer' }}>
      <h4 style={{ margin:'0 0 4px' }}>{z.n}</h4>
      <div className="khas-loc">{z.k}, {z.p}</div>
      {tipeLabel && (
        <span style={{
          display:'inline-block', margin:'6px 0',
          background:'var(--khas-green-l)', color:'var(--khas-green-d)',
          border:'1px solid #a7f3d0', padding:'2px 10px',
          borderRadius:99, fontSize:11, fontWeight:600,
        }}>
          {tipeLabel}
        </span>
      )}
      <div className="khas-zmeta">
        <span>{z.t} tenant</span>
        <span>{z.y}</span>
      </div>
    </div>
  )
}

/* ── DirektoriTab ─────────────────────────────────────────── */
function DirektoriTab() {
  const [zonaList,      setZonaList]      = useState([])
  const [loading,       setLoading]       = useState(true)
  const [search,        setSearch]        = useState('')
  const [filterTipe,    setFilterTipe]    = useState('')
  const [filterFrom,    setFilterFrom]    = useState('')
  const [filterTo,      setFilterTo]      = useState('')
  const [selectedZona,  setSelectedZona]  = useState(null)
  const [detailData,    setDetailData]    = useState(null)
  const [loadingDetail, setLoadingDetail] = useState(false)

  useEffect(() => {
    penetapanApi.getPublik()
      .then(data => setZonaList((data.penetapan || []).map(mapToZona)))
      .catch(err => console.error(err))
      .finally(() => setLoading(false))
  }, [])

  const years = [...new Set(zonaList.map(z => z.y))].sort((a, b) => a - b)

  const filtered = zonaList.filter(z => {
    if (filterTipe && z.tipe !== filterTipe)       return false
    if (filterFrom && z.y < Number(filterFrom))    return false
    if (filterTo   && z.y > Number(filterTo))      return false
    if (search) {
      const q = search.toLowerCase()
      return z.n?.toLowerCase().includes(q) ||
             z.k?.toLowerCase().includes(q) ||
             z.p?.toLowerCase().includes(q)
    }
    return true
  })

  const hasFilter  = !!(search || filterTipe || filterFrom || filterTo)
  const resetFilter = () => { setSearch(''); setFilterTipe(''); setFilterFrom(''); setFilterTo('') }

  const openModal = async (zona) => {
    setSelectedZona(zona)
    setDetailData(null)
    setLoadingDetail(true)
    try {
      const ptRes  = await penetapanApi.getById(zona.id)
      const ptData = ptRes.penetapan
      if (ptData?.pengajuan_id) {
        const pgRes = await pengajuanApi.getById(ptData.pengajuan_id)
        setDetailData({ penetapan: ptData, pengajuan: pgRes.pengajuan })
      } else {
        setDetailData({ penetapan: ptData, pengajuan: null })
      }
    } catch (err) { console.error(err) }
    setLoadingDetail(false)
  }

  const closeModal = () => { setSelectedZona(null); setDetailData(null) }

  if (loading) return (
    <div style={{ textAlign:'center', padding:60 }}>
      <div className="loader" />
    </div>
  )

  return (
    <div>
      {/* Filter 1 baris */}
      <div style={{ display:'flex', gap:8, alignItems:'center', marginBottom:16, flexWrap:'nowrap', overflowX:'auto' }}>
        <div style={{ flexShrink:0, flex:1, minWidth:180 }}>
          <KhasSearchInput
            value={search}
            onChange={e => setSearch(e.target.value)}
            placeholder="Cari nama kawasan, kota, atau provinsi..."
          />
        </div>
        <select className="khas-input"
          style={{ flexShrink:0, width:'auto', minWidth:160, height:40 }}
          value={filterTipe}
          onChange={e => setFilterTipe(e.target.value)}>
          <option value="">Semua Tipe</option>
          {TIPE_KAWASAN.map(t => (
            <option key={t.value} value={t.value}>{t.label}</option>
          ))}
        </select>
        <select className="khas-input"
          style={{ flexShrink:0, width:'auto', minWidth:110, height:40 }}
          value={filterFrom}
          onChange={e => setFilterFrom(e.target.value)}>
          <option value="">Dari tahun</option>
          {years.map(y => <option key={y} value={y}>{y}</option>)}
        </select>
        <select className="khas-input"
          style={{ flexShrink:0, width:'auto', minWidth:120, height:40 }}
          value={filterTo}
          onChange={e => setFilterTo(e.target.value)}>
          <option value="">Sampai tahun</option>
          {years.map(y => <option key={y} value={y}>{y}</option>)}
        </select>
        {hasFilter && (
          <button className="khas-btn khas-btn-outline khas-btn-sm"
            style={{ flexShrink:0 }} onClick={resetFilter}>
            Reset
          </button>
        )}
      </div>

      <p style={{ fontSize:13, color:'var(--khas-muted)', marginBottom:14 }}>
        Menampilkan <b>{filtered.length}</b> dari <b>{zonaList.length}</b> zona
      </p>

      {filtered.length === 0 ? (
        <div className="khas-card">
          <div className="khas-empty">
            <div style={{ fontSize:36, marginBottom:10, opacity:.4 }}>—</div>
            <b>Tidak ada hasil</b>
            <p style={{ margin:'8px 0', fontSize:13.5, color:'var(--khas-muted)' }}>
              Coba ubah kata kunci atau filter.
            </p>
          </div>
        </div>
      ) : (
        <div className="khas-zlist">
          {filtered.map((z, i) => (
            <ZCard key={z.id || z.n + i} z={z} onClick={() => openModal(z)} />
          ))}
        </div>
      )}

      {selectedZona && (
        <ZonaModal
          zona={selectedZona}
          detailData={detailData}
          loading={loadingDetail}
          onClose={closeModal}
        />
      )}
    </div>
  )
}

export default DirektoriTab